<template>
    <Head title="Manage Shift"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <div class="my-2">
                            <Button
                                label="New"
                                icon="pi pi-plus"
                                class="p-button-success mr-2"
                                @click="openNew"
                            />
                            <Button
                                label="Delete"
                                icon="pi pi-trash"
                                class="p-button-danger"
                                @click="confirmDeleteSelected"
                                :disabled="
                                    !selectedModels || !selectedModels.length
                                "
                            />
                        </div>
                    </template>
                </Toolbar>

                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    :selectAll="selectAll"
                    @select-all-change="onSelectAllChange"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Manage Shift</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="filters['global'].value"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                        headerStyle="width: 3rem"
                    ></Column>
                    <Column
                        field="code"
                        header="No"
                        :sortable="true"
                        headerStyle="width:5%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Id</span>
                            {{ slotProps.data.id }}
                        </template>
                    </Column>
                    <Column
                        field="name"
                        header="Nama Shift"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Nama Shift</span>
                            {{ slotProps.data.name }}
                        </template>
                    </Column>
                    <Column
                        field="jam_masuk"
                        header="Jam Masuk"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Jam Masuk</span>
                            {{ slotProps.data.jam_masuk }}
                        </template>
                    </Column>
                    <Column
                        field="jam_keluar"
                        header="Jam Keluar"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Jam Keluar</span>
                            {{ slotProps.data.jam_keluar }}
                        </template>
                    </Column>
                    <Column headerStyle="width:15%;min-width:10rem;">
                        <template #body="slotProps">
                            <Button
                                icon="pi pi-pencil"
                                class="p-button-rounded p-button-success mr-2"
                                @click="editModel(slotProps.data)"
                            />
                            <Button
                                icon="pi pi-trash"
                                class="p-button-rounded p-button-warning mt-2"
                                @click="confirmDeleteModel(slotProps.data)"
                            />
                        </template>
                    </Column>
                </DataTable>

                <Dialog
                    v-model:visible="modelDialog"
                    :style="{ width: '450px' }"
                    :header="'Shift Detail'"
                    :modal="true"
                    class="p-fluid"
                >
                    <div class="field">
                        <label for="name">Nama Shift</label>
                        <InputText
                            id="name"
                            v-model="model.name"
                            required="true"
                            :class="{ 'p-invalid': submitted && !model.name }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.name"
                            >{{ $t('name') }} is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="jam_masuk">Jam Masuk</label>
                        <Calendar
                            id="jam_masuk"
                            v-model="model.jam_masuk"
                            required="true"
                            :class="{ 'p-invalid': submitted && !model.jam_masuk }"
                            :showTime="true"
                            hour-format="24"
                            :timeOnly="true"
                        />
                        <small class="p-invalid" v-if="submitted && !model.jam_masuk"
                            >Jam Masuk is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="jam_keluar">Jam Keluar</label>
                        <Calendar
                            id="jam_keluar"
                            v-model="model.jam_keluar"
                            required="true"
                            :class="{ 'p-invalid': submitted && !model.jam_keluar }"
                            :showTime="true"
                            hour-format="24"
                            :timeOnly="true"
                        />
                        <small class="p-invalid" v-if="submitted && !model.jam_keluar"
                            >Jam Keluar is required.</small
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="hideDialog"
                        />
                        <Button
                            label="Save"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="saveModel"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="deleteModelDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete
                            <b>{{ model.name }}</b
                            >?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteModel"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="deleteModelsDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete the selected
                            models?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelsDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteSelectedModels"
                        />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import AppLayout from "../../Layouts/AppLayout";
    import { FilterMatchMode } from "primevue/api";
    import { Head } from "@inertiajs/inertia-vue3";
    import Checkbox from "primevue/checkbox";
    import Button from "primevue/button";
    import InputText from "primevue/inputtext";
    import Password from "primevue/password";
    import Message from "primevue/message";
    import Toolbar from "primevue/toolbar";
    import Toast from "primevue/toast";
    import FileUpload from "primevue/fileupload";
    import Calendar from "primevue/calendar";
    import DataTable from "primevue/datatable";
    import Column from "primevue/column";
    import InputNumber from "primevue/inputnumber";
    import Dropdown from "primevue/dropdown";
    import RadioButton from "primevue/radiobutton";
    import Dialog from "primevue/dialog";
    import DatatableService from "../../Services/DatatableService";
    import axios from "axios";
    export default {
        naem: 'Index',
        layout: AppLayout,
        components: {
            Head,
            Checkbox,
            Button,
            InputText,
            Password,
            Message,
            Toolbar,
            Toast,
            FileUpload,
            DataTable,
            Column,
            InputNumber,
            Dropdown,
            RadioButton,
            Dialog,
            Calendar,
        },
        data() {
            return {
                searchFilter: "",
                filters: {
                    global: {
                        value: null,
                        matchMode: FilterMatchMode.CONTAINS,
                    },
                    status: { value: null, matchMode: FilterMatchMode.EQUALS },
                },
                lazyParams: {
                    global: {
                        value: null,
                        matchMode: FilterMatchMode.CONTAINS,
                    },
                    status: { value: null, matchMode: FilterMatchMode.EQUALS },
                },
                totalRecords: 0,
                loading: false,
                model: {},
                submitted: false,
                modelDialog: false,
                models: null,
                deleteModelDialog: false,
                deleteModelsDialog: false,
                selectedModels: null,
                submitted: false,
                selectAll: false,
            }
        },
        datatableService: null,
        created() {
            this.datatableService = new DatatableService();
            this.initFilters();
        },
        mounted() {
            this.lazyParams = {
                first: 0,
                rows: this.$refs.dt.rows,
                sortField: "id",
                sortOrder: -1,
                filters: this.filters,
            },
            this.loadLazyData()
        },
        methods: {
            loadLazyData() {
                this.loading = true
                this.datatableService
                    .getData(this.route('api.shift.index'), this.lazyParams)
                    .then(data => {
                        this.models = data.data.data;
                        this.totalRecords = data.data.length;
                    })
                this.loading = false;
            },
            onSelectAllChange(event) {
                const selectAll = event.checked;
                if (selectAll) {
                    this.datatableService.getData(this.route("api.shift.index"),this.lazyParams).then((data) => {
                        this.selectAll = true;
                        this.selectedModels = data.data.data;
                    });
                } else {
                    this.selectAll = false;
                    this.selectedModels = [];
                }
            },
            onRowSelect() {
                this.selectAll = this.selectedModels.length === this.totalRecord;
            },
            onRowUnselect() {
                this.selectAll = false;
            },
            onPage(event) {
                this.lazyParams = event;
                this.loadLazyData();
            },
            onSort(event) {
                this.lazyParams = event;
                this.loadLazyData();
            },
            onFilter(event) {
                this.loadLazyData();
            },
            openNew() {
                this.model = {};
                this.submitted = false;
                this.modelDialog = true;
            },
            hideDialog() {
                this.modelDialog = false;
                this.submitted = false;
            },
            saveModel() {
                this.submitted = true
                if(this.model){
                    let { jam_masuk, jam_keluar } = this.model
                    if(jam_masuk instanceof Date) {
                        jam_masuk = new Date(jam_masuk)
                        this.model.jam_masuk = `${("0" + jam_masuk.getHours()).slice(-2)}:${("0" + jam_masuk.getMinutes()).slice(-2)}`
                    }
                    if(jam_keluar instanceof Date) {
                        jam_keluar = new Date(jam_keluar)
                        this.model.jam_keluar = `${("0" + jam_keluar.getHours()).slice(-2)}:${("0" + jam_keluar.getMinutes()).slice(-2)}`
                    }

                    const data = {
                        nama_shift: this.model.name,
                        jam_masuk: this.model.jam_masuk,
                        jam_keluar: this.model.jam_keluar
                    }

                    if(this.model.id) {
                        axios
                            .put(this.route('api.shift.update', this.model.id), data)
                            .then((response) => {
                                this.$toast.add({
                                    severity: "success",
                                    summary: "Successful",
                                    detail: "Shift Updated",
                                    life: 3000,
                                });
                                this.loadLazyData()
                                this.modelDialog = false
                                this.submitted = false
                            })
                            .catch((error) => {
                                this.$toast.add({
                                    severity: "error",
                                    summary: "Error",
                                    detail: "Shift not updated",
                                    life: 3000,
                                });
                            });

                        return;
                    }

                    axios.post(this.route('api.shift.store'), data)
                    .then((response) => {
                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "Shift Created",
                            life: 3000,
                        });
                        this.loadLazyData()
                        this.modelDialog = false
                        this.submitted = false
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Shift not created",
                            life: 3000,
                        });
                    });
                }
            },
            editModel(model) {
                this.model = { ...model };
                this.modelDialog = true;
            },
            deleteModel() {
                axios
                    .delete(this.route('api.shift.destroy', this.model.id))
                    .then((response) => {
                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "Shift Deleted",
                            life: 3000,
                        });
                        this.deleteModelDialog = false;
                        this.model = {};
                        this.loadLazyData();
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Shift not deleted",
                            life: 3000,
                        });
                    });
            },
            confirmDeleteModel(model) {
                this.model = model;
                this.deleteModelDialog = true;
            },
            confirmDeleteSelected() {
                this.deleteModelsDialog = true;
            },
            deleteSelectedModels() {
                this.models = this.models.filter(
                    (val) => !this.selectedModels.includes(val)
                );
                this.deleteModelsDialog = false;
                this.selectedModels = null;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Models Deleted",
                    life: 3000,
                });
            },
            initFilters() {
                this.filters = {
                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                };
            },
        }
    }
</script>

<style scoped lang="scss">
@import "../../../assets/demo/badges.scss";
</style>
